import { DoneAll, ForumRounded, Home, LocalLibrary, Person } from '@mui/icons-material';
import { ReactComponent as Progress } from 'assets/icons/Progress.svg';
import { NavbarItem, TabItem } from './types';

export const tabletMobileNavbarItems: TabItem[] = [
  {
    label: 'checklist_tab_text',
    icon: DoneAll,
    route: '/home?section=checklist',
    tabValue: NavbarItem.CHECKLIST,
  },
  {
    label: 'progress_tab_text',
    icon: Progress,
    route: '/progress',
    tabValue: NavbarItem.PROGRESS,
  },
  {
    label: 'messages_tab_text',
    icon: ForumRounded,
    route: '/home?section=chat',
    tabValue: NavbarItem.CHAT,
  },
  {
    label: 'resource',
    icon: LocalLibrary,
    route: '/resources',
    tabValue: NavbarItem.RESOURCES,
  },
  {
    label: 'Profile',
    icon: Person,
    route: '/profile',
    tabValue: NavbarItem.PROFILE,
  },
];

export const desktopNavbarItems: TabItem[] = [
  {
    label: 'home',
    icon: Home,
    route: '/home',
    tabValue: NavbarItem.HOME,
  },
  {
    label: 'progress_tab_text',
    icon: Progress,
    route: '/progress',
    tabValue: NavbarItem.PROGRESS,
  },
  {
    label: 'resource',
    icon: LocalLibrary,
    route: '/resources',
    tabValue: NavbarItem.RESOURCES,
  },
  {
    label: 'Profile',
    icon: Person,
    route: '/profile',
    tabValue: NavbarItem.PROFILE,
  },
];
